import { render } from "./htmlBox.vue?vue&type=template&id=6316d9f4&scoped=true"
import script from "./htmlBox.vue?vue&type=script&lang=js"
export * from "./htmlBox.vue?vue&type=script&lang=js"

import "./htmlBox.vue?vue&type=style&index=0&id=6316d9f4&scoped=true&lang=scss"
import "./htmlBox.vue?vue&type=style&index=1&id=6316d9f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6316d9f4"]])

export default __exports__